import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import './App.scss';
import Routes from './components/views/Routes';
import AmplifyHelper from './shared/AmplifyHelper';
import { SetUserObject } from './store/actions/user/UserActions';

function App(props: IAppProps) {
  const [foundUserObject, setFoundUserObject] = useState(false);

  useEffect(() => {
    const setUserObject = async () => {
      try {
        const userObject = (await AmplifyHelper.GetCurrentUser()) as ICognitoUser;
        props.setUserObject(userObject);
      } catch (loginError: any) {
        console.log(loginError.message);
      }
      setFoundUserObject(true);
    };
    setUserObject();
  });

  return foundUserObject ? <Routes /> : <div>Loading...</div>;
}

const dispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => ({
  setUserObject: (userObject: {}) => dispatch(SetUserObject(userObject)),
});

export default connect(undefined, dispatchToProps)(App);
